import { React, useState, useContext } from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from '../../../../App';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import { generateListReportRural } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { getFormattedDate, isEndDateGreater, changeDateFormat } from "../../../../Custom/Custom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import priceTitle from '../../../../price.json';


const ListReportRuralWages = () => {
    // const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [gender, setGender] = useState('men'); // State for gender
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();

    //handle excel sheet ***************
    const handleGenerateExcel = async () => {
        if (!startDate || !endDate) {
            toast.error('Please select the date range', messages.COLOR_RED);
            return;
        }
        if (!isEndDateGreater(startDate, endDate)) {
            toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
            return;
        }

        let sDate = getFormattedDate(startDate);
        let eDate = getFormattedDate(endDate);

        try {
            showLoading(true);
            let post_data = {
                fromDate: sDate,
                toDate: eDate,
                reportType: gender // Include gender in the request
            }

            const response = await axios.post(`${API_URL}api/price/ListReportRuralWage`, post_data, config);
            const reportData = response.data;
            if (reportData.status) {
                let allData = reportData.data.GroupCodes;

                // if (allData && Array.isArray(allData)) {
                //     allData.sort((a, b) => {
                //       const districtCodeA = a.DISTRICT_CODE ? parseInt(a.DISTRICT_CODE, 10) : 0;
                //       const districtCodeB = b.DISTRICT_CODE ? parseInt(b.DISTRICT_CODE, 10) : 0;
                //       return districtCodeA - districtCodeB;
                //     });
                //   }           

                downloadReport(allData, sDate, eDate);
            } else {
                toast.error('Data is not found', messages.COLOR_RED);
            }

        } catch (error) {
            console.error(error);
        } finally {
            showLoading(false);
        }
    }

    const formatGrossValue = (value) => {
        if (value === 0) return '0.00';
        if (value === "NaN") return '';
        if (value === '' || value === null) return '';
        return Number(value).toFixed(2);
    };

    const downloadReport = (allData, sDate, eDate) => {
        const transformedData = allData.map((item, index) => {
            return gender === 'men' ? [
                item.DISTRICT_NAME,
                item.MONTH,
                formatGrossValue(item.CARPENTER),
                formatGrossValue(item.MASON),
                formatGrossValue(item.TAILOR),
                formatGrossValue(item.BARBER),
                formatGrossValue(item.EXPELLER),
                formatGrossValue(item.BRICKS),
                formatGrossValue(item.COW),
                formatGrossValue(item.BUFFALO),
                formatGrossValue(item.PLOUGHING),
                formatGrossValue(item.SHOWING),
                formatGrossValue(item.WEEDING),
                formatGrossValue(item.HARVESTING),
                formatGrossValue(item.THRESHING),
                formatGrossValue(item.OTHER)
            ] : [
                item.DISTRICT_NAME,
                item.MONTH,
                formatGrossValue(item.COW),
                formatGrossValue(item.BUFFALO),
                formatGrossValue(item.SHOWING),
                formatGrossValue(item.WEEDING),
                formatGrossValue(item.HARVESTING),
                formatGrossValue(item.THRESHING),
                formatGrossValue(item.OTHER)
            ];
        });

        function getCurrentDateTime() {
            const now = new Date();
            const month = (now.getMonth() + 1).toString().padStart(2, '0');
            const day = now.getDate().toString().padStart(2, '0');
            const year = now.getFullYear();
            const hours = now.getHours().toString().padStart(2, '0');
            const minutes = now.getMinutes().toString().padStart(2, '0');
            const seconds = now.getSeconds().toString().padStart(2, '0');
            return `${month}/${day}/${year}, ${hours}:${minutes}:${seconds}`;
        }

        let excelObjectData = {
            fileName: `RuralWageRateOPReport_${gender}_${sDate}-${eDate}`,
            fileType: 'xls',
            sheetName: 'RuralWageRateReport',
            firstRowMergeCells: gender === 'men' ? 'A1:P1' : 'A1:I1',
            firstRowExportDate: getCurrentDateTime(),
            secondRowMergeCells: gender === 'men' ? 'A2:P2' : 'A2:I2',
            secondRowText: `   Rural Wage ${gender} ${sDate}-${eDate} (Base Year 2011-12=100)`,
            headerEnglishColumns: gender === 'men' ?
                ['DISTRICT_NAME', 'MONTH', 'CARPENTER', 'MASON', 'TAILOR', 'BARBER', 'EXPELLER', 'BRICKS', 'COW', 'BUFFALO', 'PLOUGHING', 'SHOWING', 'WEEDING', 'HARVESTING', 'THRESHING', 'OTHER']
                :
                ['DISTRICT_NAME', 'MONTH', 'COW', 'BUFFALO', 'SHOWING', 'WEEDING', 'HARVESTING', 'THRESHING', 'OTHER'],
            excelRowData: transformedData,
            reportType:gender,
        };

        generateListReportRural(excelObjectData);
    }


    return (
        <>
            <ToastContainer />
            <GlobalLoading />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.LIST_REPORT_RURAL_WAGES : priceTitle.en.LIST_REPORT_RURAL_WAGES }} />
                            </h4>



                            <div className="row align-items-center">


                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">Select Report For</label>
                                    <select className="form-select" value={gender} onChange={(e) => setGender(e.target.value)}>
                                        {/* <option value="">Select Gender</option> */}
                                        <option value="men">Men</option>
                                        <option value="women">Women</option>
                                    </select>
                                </div>


                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">From Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={startDate}
                                        onChange={(e) => { setStartDate(e) }}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        maxDate={today}
                                    />
                                </div>

                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">To Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={endDate}
                                        onChange={(e) => { setEndDate(e) }}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        maxDate={today}
                                    />
                                </div>


                                <div className="col-xl-2 col-lg-4 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ListReportRuralWages